<div class="containerForm">
  <iframe
    *ngIf="idioma == 'es'"
    src="https://firebasestorage.googleapis.com/v0/b/thecampus-colegios.firebasestorage.app/o/MANUALES%2FManual_Alumno_TheCampus(ESP).pdf?alt=media&token=80df8d89-ef1d-4856-962d-9cad2be3a238"
    name="iframe1"
    id="iframe1"
    width="100%"
    height="100%"
  ></iframe>
  <iframe
    *ngIf="idioma != 'es'"
    src="https://firebasestorage.googleapis.com/v0/b/thecampus-colegios.firebasestorage.app/o/MANUALES%2FManual_Alumno_TheCampus(ESP).pdf?alt=media&token=80df8d89-ef1d-4856-962d-9cad2be3a238"
    name="iframe1"
    id="iframe1"
    width="100%"
    height="100%"
  ></iframe>
</div>
